import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchDayBook } from './api';

/**
 * Branch-scoped — collections land in one physical till, so a group-level
 * roll-up here would be a number no single cashier could act on. Same
 * date-range-as-part-of-the-key pattern as usePharmacyReport, for the same
 * reason: flipping back to a range already viewed is instant.
 */
export function useDayBook(from: string, to: string, department: string | null = null) {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.reports.dayBook(from, to), department ?? 'all', branchVersion],
    queryFn: () => fetchDayBook(from, to, department),
    enabled: !!from && !!to,
    placeholderData: (prev) => prev,
  });
}
